import { Component, OnInit, OnChanges, Output, Input, SimpleChanges, EventEmitter, ViewChild, OnDestroy, AfterViewInit, NgZone } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { CompanySettingsService } from 'src/app/reusables/services/company-settings.service';
import { CvConfigurationService } from 'src/app/reusables/services/cv-configuration.service';
import { CvCustomDialogService } from 'src/app/reusables/custom-dialog/cv-custom-dialog.service';
import { CVLocalizationService } from 'src/app/reusables/services/cv-localization.service';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { PointStoreNavigationBarService } from '../../services/point-store-navigation-bar.service';
import { PointStorePermissionService } from '../../services/point-store-permission.service';
import { PointStoreProductEditSaveService } from '../../services/point-store-product-edit-save.service';
import { PointStoreProductEditService } from '../../services/point-store-product-edit.service';
import { ProductsFilterPipe } from '../../custom-pipes/products-filter.pipe';
import { ShoppingCartService } from '../../../agent-side/services/shopping-cart.service';
import { ToastrManager } from '@niceltd/cxone-components/toastr';

import moment from 'moment';

@Component({
  selector: 'cv-point-store-product-landing-thumbnail',
  templateUrl: './point-store-product-landing-thumbnail.component.html',
  styleUrls: ['./point-store-product-landing-thumbnail.component.scss'],
  preserveWhitespaces: true
})
export class PointStoreProductLandingThumbnailComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @ViewChild(CdkVirtualScrollViewport, { static: false })  scrollViewPort: CdkVirtualScrollViewport;

  pspes: any = null;
  psnbs: any = null;
  scs: any = null;
  SortType = null;
  generic_msgs = null;
  DateFormat = CVMediumDateFormat;
  filteredProducts = [];
  productsByRow = [];
  sortOptionsCXOne = [];

  _localizationStrings = new Map(); // This is used for localizations.
  _localizationStringsMarketplace = new Map(); // This is used for localizations.
  LocalizationMessages: any = null;

  //display label with number of products
  @Output() loadCountProducts: EventEmitter<number> = new EventEmitter<number>();
  @Input() productList: any[] = [];
  @Input() sortOptions: any[] = [];
  
  popoverItem: any;
  isLoading: boolean = false;

  rowClass: string = "col-lg-6";
  private resizeObserver: ResizeObserver;
  private chunkSizeState = new BehaviorSubject<{ oldValue: number, newValue: number }>({
    oldValue: 4,
    newValue: 4
  });
  chunkSizeValue$ = this.chunkSizeState.asObservable();

  constructor(
    private cvLocalizationService: CVLocalizationService,
    private pointStoreProductEditSaveService: PointStoreProductEditSaveService,
    private pointStoreProductEditService: PointStoreProductEditService,
    private pointStoreNavigationBarService: PointStoreNavigationBarService,
    private companySettingsService: CompanySettingsService,
    private dialogService: CvCustomDialogService,
    private filter: ProductsFilterPipe,
    public config: CvConfigurationService,
    private PointStorePermissionService: PointStorePermissionService,
    private toastrManager: ToastrManager,
    private zone: NgZone
  ) { }

  ngOnDestroy() {
    this.resizeObserver.unobserve(document.getElementById('productContainer'));
  }

  ngAfterViewInit() {
    this.resizeContainer();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes?.productList?.currentValue !== null && changes?.productList?.currentValue?.length > 0) {
      this.updateProductsByRow();
    }
    if(changes?.sortOptions?.currentValue !== null && changes?.sortOptions?.currentValue?.length > 0){
      this.loadSortOptions();
    }
  }

  async ngOnInit() {
    this.pspes = this.pointStoreProductEditService.pointStoreProductEditObj;
    this.psnbs = this.pointStoreNavigationBarService.data;
    this.loadLocalizationsMessages();
    this.cvLocalizationService.GetSection("Common");
    this.cvLocalizationService.GetSection("MarketPlace_Management_Product_Operation");
  }

  loadLocalizationsMessages() {
    this.cvLocalizationService.GetSection("MarketPlace_Management_Messages").then(
      (result) => {
        this.LocalizationMessages = result;
      }
    );
    this.companySettingsService.loadLoggedInCompanyValues();
    if (this.pspes.collection.originalData && this.pspes.collection.originalData.length > 0) {
      this.updateProductsByRow();
    }
  }

  updateProductsByRow() {
    this.isLoading = true;
    // filter products
    let filteredProducts = [];
    this.productList?.forEach(product => {
      if (this.pointStoreProductEditService.setFilterMatches(product))
        filteredProducts.push(product);
    });
    filteredProducts = this.filter.transform(filteredProducts, this.config.isCxOne ? this.SortType?.value ?? 'Title' : this.SortType);

    if (this.config.isCxOne) {
      this.loadCountProducts.emit(filteredProducts.length);
    } else {
      this.sortByHighlightProdList(filteredProducts);
    }
    const size = this.config.isCxOne ? this.chunkSizeState.value.newValue : 4;
     // group into rows
     this.productsByRow = [];
     if (filteredProducts && filteredProducts.length) {
       for (let i = 0; i < filteredProducts.length; i++) {
        //setting the correct chunk size based in the cxone value
         let rowIndex = Math.floor(i / size);
         let offset = i % size;
         // create row array if necessary
         if (!this.productsByRow[rowIndex])
           this.productsByRow[rowIndex] = [];

         this.productsByRow[rowIndex][offset] = filteredProducts[i];
       }
     }
    
    this.isLoading = false;
  };



  filterMatches(product) {
    return this.pointStoreProductEditService.setFilterMatches(product);
  };

  CreatePointStoreProduct() {
    this.pointStoreProductEditService.getNewPointStoreProduct();
    this.pointStoreNavigationBarService.setSelectedFrame(1);
  };

  EditPointStoreProduct(product) {
    this.pointStoreProductEditService.pointStoreProductEditObj.copiedProduct = false;
    product.CarouselStart = product.CarouselStart ? new Date(product.CarouselStart) : null;
    product.CarouselEnd = product.CarouselEnd ? new Date(product.CarouselEnd) : null;
    product.FeatureStart = product.FeatureStart ? new Date(product.FeatureStart) : null;
    product.FeatureEnd = product.FeatureEnd ? new Date(product.FeatureEnd) : null;
    product.SaleStart = product.SaleStart ? new Date(product.SaleStart) : null;
    product.SaleEnd = product.SaleEnd ? new Date(product.SaleEnd) : null;
    product.ProductStart = product.ProductStart ? new Date(product.ProductStart) : null;
    product.ProductEnd = product.ProductEnd ? new Date(product.ProductEnd) : null;
    this.pointStoreProductEditService.setEditPointStoreProduct(product);
    this.pointStoreNavigationBarService.setSelectedFrame(1);
  };

  EditPointStoreProductCxone(product) {
    this.pointStoreProductEditService.pointStoreProductEditObj.copiedProduct = false;
    product.CarouselStart = product.CarouselStart ? new Date(product.CarouselStart) : null;
    product.CarouselEnd = product.CarouselEnd ? new Date(product.CarouselEnd) : null;
    product.FeatureStart = product.FeatureStart ? new Date(product.FeatureStart) : null;
    product.FeatureEnd = product.FeatureEnd ? new Date(product.FeatureEnd) : null;
    product.SaleStart = product.SaleStart ? new Date(product.SaleStart) : null;
    product.SaleEnd = product.SaleEnd ? new Date(product.SaleEnd) : null;
    product.ProductStart = product.ProductStart ? new Date(product.ProductStart) : null;
    product.ProductEnd = product.ProductEnd ? new Date(product.ProductEnd) : null;
    this.pointStoreProductEditService.setEditPointStoreProduct(product);
    this.pointStoreNavigationBarService.setSelectedFrame(6);
  };

  async RemovePointStoreProduct(product) {
    if (this.config.isCxOne) {
      const modalTitle = this.cvLocalizationService.getCachedText('MarketPlace_Management_Product_Operation', 'Delete_Product_Modal_Title', 'Delete Product?');
      const buttonTitle = this.cvLocalizationService.getCachedText('MarketPlace_Management_Product_Operation', 'Delete_Product_Button_Title', 'Delete');
      const prompt = this.cvLocalizationService.getCachedText('MarketPlace_Management_Messages', 'Validate_Delete_Product_Cxone', 'This will affect wishlist and existing products.');
      const cancelLabel = this.cvLocalizationService.getCachedText('MarketPlace_Management', 'Cancel', 'Cancel');
      const removeModal: NgbModalRef = this.dialogService.showDialog(modalTitle, prompt, 1, cancelLabel, buttonTitle, true, () => this.removeProductOperation(product));
    } else {
      const result = await this.pointStoreProductEditSaveService.confirmRemoveProduct(product);
      if (result) {
        this.removeProductOperation(product);
      }
    }

    /* this.pointStoreProductEditSaveService.confirmRemoveProduct(product).then(
       (result) => this.pointStoreProductEditSaveService.removeProduct(product)
     ).then(
       (innerResult) => {
         let index = this.PointStoreProductEditService.getIndexByProductIDFromOriginal(product.PointStoreProductID);
         this.pointStoreProductEditSaveService.pspef.collection.originalData.splice(index, 1);
         //We need to update the object ProductsByRow, object assigned to the view
         this.updateProductsByRow();
       })
       .catch((error) => showErrorMessage(error));  */
  };

  async removeProductOperation(product: any) {
    try {
      const deletedProd = await this.pointStoreProductEditSaveService.removeProduct(product);
      let index = this.pointStoreProductEditService.getIndexByProductIDFromOriginal(product.PointStoreProductID);
      this.pointStoreProductEditSaveService.pspef.collection.originalData.splice(index, 1);
      //We need to update the object ProductsByRow, object assigned to the view
      this.updateProductsByRow();
      if(deletedProd && this.config.isCxOne){
        this.toastrManager.showToaster('success', this.cvLocalizationService.getCachedText("MarketPlace_Management", "Delete_Product_Success", "Product deleted successfully."));
      }
    } catch (error) {
      if (error.status_code === 401) {
        if (this.config.isCxOne) {
          this.dialogService.showDialog(this.cvLocalizationService.getCachedText("MarketPlace_Management_Product_Operation", "Unauthorized_Access", "Unauthorized Access"), error.message, 1, this.cvLocalizationService.getCachedText("Common", "Cancel_Button", "Cancel"), this.cvLocalizationService.getCachedText("Common", "Ok", "Ok"), true);
        } else {
          this.PointStorePermissionService.validationMessage(error.message);
        }

      } else {
        showErrorMessage(error)
      }
    }
  }

  CopyPointStoreProduct(product) {
    let copy = this.pointStoreProductEditSaveService.copyPointStoreProduct(product);
    this.EditPointStoreProduct(copy);
    this.pointStoreProductEditService.pointStoreProductEditObj.copiedProduct = true;
  };

  CopyPointStoreProductCxone(product) {
    let copy = this.pointStoreProductEditSaveService.copyPointStoreProduct(product);
    this.EditPointStoreProductCxone(copy);
    this.pointStoreProductEditService.pointStoreProductEditObj.copiedProduct = true;
  };

  /*  productPrice(product){
     let finalProductPrice = '0';
     let initialVariation = this.calculateInitialVariationPrice(product);
     let lastVariation = this.calculateLastVariationPrice(product);
 
     if(product.HasProductVariations && product.HasVariationPrices && product.VariationsData){
       let initialVariationPrice = this.calculateVariationPrice(product.Sale, initialVariation.VariationPrice, initialVariation.VariationOnSale);
       let lastVariationPrice = this.calculateVariationPrice(product.Sale, lastVariation.VariationPrice, initialVariation.VariationOnSale);
       finalProductPrice = new CvNumberLocalizePipe().transform(Math.ceil(initialVariationPrice)) + " - " + new CvNumberLocalizePipe().transform(Math.ceil(lastVariationPrice));      
     }else{
       finalProductPrice = product.Price;
     }
     return finalProductPrice;
   }
 
   calculateVariationPrice(productSale, variationPrice, variationOnSale) {
     return variationOnSale ? Math.ceil(variationPrice - ((productSale / 100.0) * variationPrice)) : variationPrice;
   }
 
   calculateInitialVariationPrice(product) {
     let initialVariation = product.VariationsData.reduce((prev, curr) => {
       let prevValue = prev.VariationPrice;
       let currValue = curr.VariationPrice;
       if (prev.VariationOnSale)
         prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
       if (curr.VariationOnSale)
         currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
       return prevValue < currValue ? prev : curr;
     });
     return initialVariation;
   }
 
   calculateLastVariationPrice(product) {
     let lastVariation = product.VariationsData.reduce((prev, curr) => {
       let prevValue = prev.VariationPrice;
       let currValue = curr.VariationPrice;
       if (prev.VariationOnSale)
         prevValue = prev.VariationPrice - (prev.VariationPrice * (product.Sale / 100));
       if (curr.VariationOnSale)
         currValue = curr.VariationPrice - (curr.VariationPrice * (product.Sale / 100));
       return prevValue > currValue ? prev : curr;
     });
     return lastVariation;
   } */

  showSale(product) {
    if (product.Sale <= 0 || product.SaleStart == null)
      return false;

    if (product.SaleEnd != null && moment().isAfter(product.SaleEnd, 'day'))
      return false;
    if (product.SaleStart != null && moment(product.SaleStart).isAfter(moment(), 'day'))
      return false;

    return true;
  }

  checkActivePopover(element) {
    if (this.popoverItem != null) {
      if (this.popoverItem.popoverId != element.popoverId && this.popoverItem.isOpen) {
        this.popoverItem.hide();
      }
    }
    this.popoverItem = element;
  }

  /**
   * 
   * @param filteredProducts 
   * @returns filteredProducts sorty by hasModifiedHighlight and prodId
   */
  sortByHighlightProdList(filteredProducts):any[] {
    //check if at least one prod has hasModifiedHighlight prop as true
    const mHprodExists = filteredProducts.some(prod => prod.hasModifiedHighlight);
    if(mHprodExists){
       //means theres at least one prod has set hasModifiedHighlight as true, sort by hasModifiedHighlight and by id desc
      return filteredProducts.sort((a, b) => {
        // Check if 'hasModifiedHighlight' property exists and is true
        const aIsHighlight = a.hasModifiedHighlight === true;
        const bIsHighlight = b.hasModifiedHighlight === true;
        if (aIsHighlight && !bIsHighlight) {
          return -1; // 'a' is hasModifiedHighlight but 'b' is not, so 'a' comes first
        }
        if (!aIsHighlight && bIsHighlight) {
          return 1; // 'b' is hasModifiedHighlight but 'a' is not, so 'b' comes first
        }
        //sort by 'id' in descending order
        return bIsHighlight ? b.PointStoreProductID - a.PointStoreProductID : 0;
      });
    }
    //if theres any prod with hasModifiedHighlight pro then return the same list
    return filteredProducts;
  }
  
  loadSortOptions(){
    if(!this.config.isCxOne){
      this.SortType = 'Title';
    }else{
      let sortOptions = [...this.sortOptions].slice(0, 4);
      if(sortOptions.length > 0){
        sortOptions.push({ value: 'PointStoreProductID', name: this.cvLocalizationService.getCachedText("MarketPlace_Management", "Created_Newest_First", "Created: Newest First") });
        sortOptions.push({ value: '-PointStoreProductID', name: this.cvLocalizationService.getCachedText("MarketPlace_Management","Created_Oldest_First", "Created: Oldest First") });
        this.sortOptionsCXOne = sortOptions;
        this.SortType = this.sortOptionsCXOne[2];
      }
    }
  }

  /**
   * displays the state based on the filters and the product list
   * @returns string of the state
   */
  displayState(): string {
    let display: string = "no-state";

    //Check for state images after the filtering process is finished
    if(!this.isLoading){
      //Checking for a no results state only when the user filters the products, no when the filtering is automatic (when the filter section gets activate)
      if(this.pointStoreProductEditService.isFilterActive() && this.productsByRow?.length === 0){
        display = "no-results-state";
      } else if(this.productList?.length === 0){
        display = "empty-state";
      }
    }

    return display;
  }

  scrollToTop(): void {
    if (this.scrollViewPort) {
      const currentScrollOffset = this.scrollViewPort.measureScrollOffset();
      if(currentScrollOffset > 0){
        this.scrollViewPort.scrollToIndex(0, 'smooth');
      }
    }
  }

  /**
   * resize the cards in the container
   */
  resizeContainer(): void{
    //search the container by id
    const element = document.getElementById('productContainer');
    //resize observer
    this.resizeObserver = new ResizeObserver((entries) => {
      this.zone.run(() => {
        //adjust the chunk size based in the container width
        this.adjustChunkSize(entries[0].contentRect.width);
      });
    });
    //validate if the element exists
    if(element){
      this.resizeObserver.observe(element);
    }
    //the product list is split based on the chunk state.
    this.chunkSizeValue$
    .subscribe({
      next: val => {
        //call updateProductsByRow only if the values are different
        if (val.oldValue !== val.newValue) {
          this.updateProductsByRow();
        }
      }
    })
  }

  /**
   * set the chunk size into the state also change the class to display 3 or 4 cards
   * @param screenWidth element width
   */
  adjustChunkSize(screenWidth:number): void {
    let chunkSize = 4;
    this.rowClass = "col-lg-6";
    if(screenWidth === 930){
      chunkSize = 3;
      this.rowClass = "col-lg-4";
    }
    this.updateChunkSizeState(chunkSize);
  }

  /**
   * refresh state to have correct value
   * @param newValue value to refresh the state
   */
  updateChunkSizeState(newValue: number): void {
    const oldValue = this.chunkSizeState.value.newValue;
    this.chunkSizeState.next({ oldValue, newValue });
  }
}
